import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const UpgradeModal = (props) => {
	const { isOpen, setIsOpen, message } = props;

	return (
		<Modal
			open={isOpen}
			onClose={() => {
				setIsOpen(false);
			}}
		>
			<div
				style={{
					position: 'relative',
					outline: 'none',
					backgroundColor: '#22262e',
					width: '50%',
					margin: 'auto',
					marginTop: '20vh',
					padding: 10,
					borderRadius: 8,
					paddingTop: 40,
					paddingBottom: 40,
				}}
			>
				<IconButton
					onClick={() => setIsOpen(false)}
					style={{
						position: 'absolute',
						top: 10,
						right: 10,
						color: 'white',
					}}
				>
					<CloseIcon />
				</IconButton>

				<h2 style={{ textAlign: 'center', fontSize: 24, fontWeight: 'bold' }}>
					{message ? message : 'Feature Unavailable'}
				</h2>
				<p
					style={{
						marginTop: 20,
						width: '60%',
						justifySelf: 'center',
						textAlign: 'center',
						marginLeft: 'auto',
						marginRight: 'auto',
					}}
				>
					Upgrade your account now to access this feature and get more value!
				</p>
				<div
					onClick={() => {
						window.location.href = '/pricing';
					}}
					style={{
						cursor: 'pointer',
						marginTop: 20,
						justifySelf: 'center',
						paddingLeft: 20,
						paddingRight: 20,
						paddingTop: 10,
						paddingBottom: 10,
						backgroundColor: '#0a63f2',
						borderRadius: 8,
						color: 'white',
						textAlign: 'center',
						width: 'fit-content',
						marginLeft: 'auto',
						marginRight: 'auto',
					}}
				>
					See plans
				</div>
			</div>
		</Modal>
	);
};

